import React from "react";
import {
  Pre,
  PreLabel,
  PreTitle,
  Section,
  StyledSectionTitle,
} from "./elements";

export const Agreement: React.FC = React.memo(() => {
  return (
    <Section>
      <StyledSectionTitle>宅配買取利用規約</StyledSectionTitle>
      <div>
        <Pre>
          <PreLabel>
            買取BestValue（以下「当WEBサイト」）をご利用頂くうえで、宅配買取、店舗買取、お電話、メール等、弊社買取サービスをご利用頂いた場合、本規約に同意頂いたとみなします。予めご了承下さい。
          </PreLabel>
          <PreLabel>買取利用規約（宅配/店舗買取共通項目）</PreLabel>
          <PreLabel>商品は必ず初期化した状態にしてください。</PreLabel>
          <PreLabel>
            おサイフケータイ、Edy、Felica、モバイルSuica、マクドナルドなどのICアプリは必ずお客様自身で初期化、削除して下さい。
          </PreLabel>
          <PreLabel>
            暗証番号・PINロックは端末初期化だけでは初期値に戻らない場合が御座いますので必ず初期値に設定して下さい。
          </PreLabel>
          <PreLabel>
            暗証番号・PINロックを解除していない場合は買取不可となります。
          </PreLabel>
          <PreLabel>
            おまかせロックサービス、ケータイ保証お届けサービス、安心保証パックに加入してある端末は買取不可となります。
          </PreLabel>
          <PreLabel>必ず解除してから当社の買取をご利用下さい。</PreLabel>
          <PreLabel>
            不正契約・不正入手した端末、及びその疑いがある端末は買取不可となります。
          </PreLabel>
          <PreLabel>
            買取の際、弊社での確認およびキャリアへの確認を行うことが御座いますのでご了承下さい。
          </PreLabel>
          <PreLabel>
            弊社との取引完了後に不正契約・入手が発覚した場合、警察への被害届提出および損害賠償請求をさせて頂きます。
          </PreLabel>
          <PreLabel>
            root権の取得、iPhoneにおける脱獄などのシステムの不正な改変、改造をされている商品は買取不可となります。
          </PreLabel>
          <PreLabel>SIMカードは必ず抜いてください。</PreLabel>
          <PreLabel>
            SIMカードの抜き忘れなどで、不正利用などの損害、トラブルが発生しても弊社では一切の責任を負いかねます。
          </PreLabel>
          <PreLabel>弊社買取価格は随時更新させていただいております。</PreLabel>
          <PreLabel>
            日中でも複数回変更になる場合がございます。予めご了承ください。
          </PreLabel>
          <PreLabel>18歳未満の方、高校生の方はご利用できません。</PreLabel>
          <PreLabel>
            PC等のデータ消去の際にリカバリー領域の消去は行わない場合がございます。
          </PreLabel>
          <PreLabel>
            eSIM対応機種はeSIMデータを必ず削除してから弊社買取をご利用ください。
          </PreLabel>
          <PreLabel>
            eSIMデータの削除忘れで、不正利用などの損害、トラブルが発生しても弊社では一切の責任を負いかねます。
          </PreLabel>
          <PreLabel>
            買取対象の端末であっても、弊社の都合により、お買取をお断りする場合があります。
          </PreLabel>
          <PreTitle>新品/未使用品について</PreTitle>
          <PreLabel>
            以下に該当する端末は中古品としての取り扱いとなります。
          </PreLabel>
          <PreLabel>
            付属品が欠品しているもの。付属品に使用感のあるもの。
          </PreLabel>
          <PreLabel>
            初期フィルムがない、もしくは１度はがした形跡のあるもの。
          </PreLabel>
          <PreLabel>
            本体交換品や修理交換品、外箱と本体記載のIMEI（製造番号）が異なるもの。
          </PreLabel>
          <PreLabel>次の状態の場合は新品として買取できません。</PreLabel>
          <PreLabel>
            SIMフリーやWi-Fi専用モデルなど新品の商品が未開封で流通する商品に関しては、開封してあるものは中古品になります。
          </PreLabel>
          <PreLabel>
            ※一部の商品は購入証明がないと新品として買取できないものがございます。
          </PreLabel>
          <PreTitle>SIMフリー端末について</PreTitle>
          <PreLabel>
            以下に該当する端末は買取をお断りする場合がございます。
          </PreLabel>
          <PreLabel>
            3Gの2100MHz帯をサポートしていないもの。(日本国内で使用できないもの)
          </PreLabel>
          <PreLabel>他国キャリアのロックがかかっている端末。</PreLabel>
          <PreLabel>
            SIMロック解除や、OS入れ替え、言語変更などメーカーがサポートしていない改造がされているもの。
          </PreLabel>
          <PreLabel>
            特殊な充電器を必要とする端末で充電器が欠品している場合。
          </PreLabel>
          <PreLabel>
            SIMフリーであることを確認するため通信テストを行わせて頂きますので国内のケータイよりもチェックおよび査定の時間がかかることが御座いますのでご了承下さいませ。
          </PreLabel>
          <PreTitle>au端末のICロックについて</PreTitle>
          <PreLabel>
            ロッククリアが必要となるau端末は、買取査定後に査定金額にご納得頂けない等キャンセルとなった場合、
          </PreLabel>
          <PreLabel>
            お客様のIC(SIM)カードで再利用出来ない場合が御座います。
          </PreLabel>
          <PreLabel>
            再度ご利用頂く場合は、auショップにてロッククリアの手続きが必要となりますが
          </PreLabel>
          <PreLabel>
            弊社では事務手数料等の手続きに必要な費用は一切負担致しませんので予めご了承下さい。
          </PreLabel>
          <PreTitle>最低買取保証金額について</PreTitle>
          <PreLabel>
            弊社では商品ごとに最低買取保証金額を設定させていただいておりますが、本体に不具合がない商品のみ適用とさせていただきます。
          </PreLabel>
          <PreLabel>
            最低買取保証金額の適用条件 本体操作、動作に不具合がない。
          </PreLabel>
          <PreLabel>
            本体、電池パックに水没反応がない。 各種データが消去されている。
          </PreLabel>
          <PreLabel>iCloud、Google等にログインされていない。</PreLabel>
          <PreLabel>
            パスワード、暗証番号が設定されていない。（各キャリア、メーカーのデファルトパスワードに設定してある。）
          </PreLabel>
          <PreLabel>
            OSやCPU、システムなどに不正な改変がない。（root化、脱獄などがされていない）
          </PreLabel>
          <PreLabel>
            液晶の映りに支障がない。（黄ばみ、輝度ムラなどがない。）
          </PreLabel>
          <PreLabel>
            液晶パネルやバックパネルが浮いていたり剥離していない。
          </PreLabel>
          <PreLabel>
            正規のメーカー以外の修理を受けていたり、正規品以外のパーツを使っていない。
          </PreLabel>
          <PreLabel>
            本体に、割れ、かけ、ヒビ、曲がり、剥がれ、欠損などがない。
          </PreLabel>
          <PreLabel>
            本体基本動作に支障のある欠品がない（SIMトレー、専用充電器、本体内蔵式のタッチペン等）
          </PreLabel>
          <PreLabel>
            本体にデコレーションやペイントがなく、また、取り外しが困難なアクセサリーなどが接着されていない。
          </PreLabel>
          <PreLabel>
            ネットワーク利用制限のある機種は(×)(ー)判定ではないもの。
          </PreLabel>
          <PreLabel>
            状態がかなり悪い場合には適用外になる場合がございます。
          </PreLabel>
          <PreLabel>
            ※上記以外にも弊社で、再販にあたり支障が生じると判断した場合には保証価格が適用できない場合がございます。
          </PreLabel>
          <PreLabel>
            検品作業について 弊社では検品時に以下の作業を行う場合がございます。
          </PreLabel>
          <PreLabel>
            そのため、残念ながらご返却となる場合には、商品状態が検品前より異なる場合がございますので、予めご了承ください。
          </PreLabel>
          <PreLabel>未開封品の開封。</PreLabel>
          <PreLabel>
            OSやシステム、アプリケーションなどのインストール、アップデート、リカバリー作業。
          </PreLabel>
          <PreLabel>
            Wi-Fi接続などのデータ通信。 各種データ、設定等の削除。
          </PreLabel>
          <PreLabel>
            保護フィルム、ケースなどを取り外しての状態確認作業。
          </PreLabel>
          <PreLabel>
            ※液晶保護フィルムはほとんどの場合、はがす際に割れたり異物の混入が起こり、再利用ができないため廃棄処分とさせていただいております。
          </PreLabel>
          <PreLabel>返却は出来かねますのであらかじめご了承ください。</PreLabel>
          <PreTitle>ネットワーク利用制限について</PreTitle>
          <PreLabel>
            ネットワーク利用制限がある機種は判定が（－）または(×)の場合は買取ができません。
          </PreLabel>
          <PreLabel>
            ネットワーク利用制限が(▲)判定の機種でも一部買取可能でございますが、買取成立後も割賦残があればお支払いを継続し、必ず完済してください。
          </PreLabel>
          <PreLabel>
            買取成立後も、使用できる状態を維持してください。代金未払いや不正契約等の理由により使用できなくなった場合には損害賠償請求を行わせて頂きます。
          </PreLabel>
          <PreLabel>
            宅配買取利用規約 日本国内からのみご利用可能とさせて頂きます。
          </PreLabel>
          <PreLabel>
            本人確認証明書の確認ができない。又はご入金先が不明である状態が1週間以上経過してもお客様よりご連絡頂けない場合はご返送させて頂きます。
          </PreLabel>
          <PreLabel>SIMカードは必ず抜いてご発送ください。</PreLabel>
          <PreLabel>
            弊社で検品時に確認されたSIMカードはすべて即時廃棄処分とさせて頂きます。
          </PreLabel>
          <PreLabel>
            誤って発送してしまった場合には弊社到着前までにご連絡ください。
          </PreLabel>
          <PreLabel>※送料は着払い(お客様ご負担)での返送となります。</PreLabel>
          <PreLabel>
            本体標準の付属品以外の商品は弊社検品時に廃棄処分とさせて頂きます。
          </PreLabel>
          <PreLabel>
            ご返送できませんのであらかじめ本体などからは外してご発送ください。（お客様で後からご購入いただいた保護フィルム、保護ケース、ストラップなど。）
          </PreLabel>
          <PreLabel>
            弊社システムエラーによる買取価格の誤表示や、予期せぬ市場価格の変動、為替、物価の下落、自然災害などが起きた場合、お申込み時の買取価格保証ができない場合がございます。
          </PreLabel>
          <PreLabel>
            同一機種(カラー関係なく)のお買取は原則お一人様4台までとさせて頂きます。
          </PreLabel>
          <PreLabel>
            5台以上ご希望のお客様は買取専用フリーダイヤルまでご相談下さい。
          </PreLabel>
          <PreLabel>
            台数が多い場合、検品作業に通常よりお時間を頂きます。
          </PreLabel>
          <PreTitle>発送、返送について</PreTitle>
          <PreLabel>
            輸送中に査定品の破損等、輸送事故が発生した場合は、弊社では一切責任を負えませんので予めご了承下さい。
          </PreLabel>
          <PreLabel>
            台風や大雪などで配送などに遅延が生じた場合には弊社では価格保証などは行っておりませんので予めご了承ください
          </PreLabel>
          <PreLabel>
            送料着払いでお送りいただく場合はヤマト運輸をご利用ください。
          </PreLabel>
          <PreLabel>
            その他の運送会社をご利用で送料着払いの場合は、お受取りいたしかねます。
          </PreLabel>
          <PreLabel>
            弊社の集荷サービスをご利用いただく際にはご選択いただいた梱包キットを持参の上、集荷にお伺いいたします。
          </PreLabel>
          <PreLabel>
            緩衝材の用意はございませんので端末等は配送時に傷がつかないよう事前に包装してください。
          </PreLabel>
          <PreLabel>
            包装が不十分の状態で配送中に傷が生じた場合にはその状態での査定価格となり、保証はできかねます。
          </PreLabel>
          <PreLabel>
            お客様で梱包資材をご用意の上、梱包発送いただく際には配送中に傷・破損が起きないように包装してください。
          </PreLabel>
          <PreLabel>
            また、弊社で過剰梱包と判断させていただいた場合には、超過料金を買取金額より差し引かせていただく場合がございます。
          </PreLabel>
          <PreLabel>
            弊社からのご連絡に１週間以上ご返答を頂けない場合や、弊社からご連絡ができない場合には、返送させて頂きます。
          </PreLabel>
          <PreLabel>
            ご返送させて頂いた際に、住所不明や受取辞退、長期不在等で弊社まで返送されてくる場合は、お客様が所有権を放棄されたとみなし、弊社で処分出来るものと致します。
          </PreLabel>
          <PreLabel>
            その際にかかった費用作業費や保管、管理費用、送料等は別途ご請求致します。
          </PreLabel>
          <PreLabel>返送はご発送元のご住所に返送とさせて頂きます。</PreLabel>
          <PreLabel>
            それ以外の住所には返送できませんのであらかじめご了承ください。
          </PreLabel>
          <PreLabel>
            返送商品に問題があった場合には到着後1週間以内のご連絡をお願い致します。
          </PreLabel>
          <PreLabel>
            到着後1週間以降にご連絡をいただいてもご対応できかねます。
          </PreLabel>
          <PreLabel>
            弊社で買取対象となっていない端末、付属品のみ、SIMカードのみ、各種書類のみなど端末本体を含まない場合の返送等は着払い(お客様負担)とさせていただきます。
          </PreLabel>
          <PreLabel>
            ご本人様確認書類について ご利用いただけるご本人様確認書類 運転免許証
          </PreLabel>
          <PreLabel>
            ※変更履歴がある場合は裏面も必要（手書きの場合は公安印が必要）
          </PreLabel>
          <PreLabel>マイナンバーカード (宅配買取では利用不可)</PreLabel>
          <PreLabel>
            ※「性別」「臓器提供意思表示」欄は隠した状態 ※通知カードは不可 各種
          </PreLabel>
          <PreLabel>健康保険被保険者証</PreLabel>
          <PreLabel>
            ※「記号」「番号」「被保険者番号(保険者番号)」「QRコード(記載がある場合)」は隠した状態
          </PreLabel>
          <PreLabel>パスポート</PreLabel>
          <PreLabel>
            ※2020年2月3日以前に申請し日本国で発行され、現住所の記載があるもの
            各種
          </PreLabel>
          <PreLabel>
            障害者手帳(身体障害者手帳/療育手帳/精神障害者保健福祉手帳)
          </PreLabel>
          <PreLabel>※顔写真のあるもの 学生証</PreLabel>
          <PreLabel>
            ※顔写真/氏名/住所/生年月日の記載があるもの。高校生は不可 在留カード
          </PreLabel>
          <PreLabel>
            ※顔写真があるもの。住居欄が空欄のものは不可 ※1回目のお取引の場合
          </PreLabel>
          <PreLabel>
            ご本人様確認書類に記載のご住所へヤマト運輸の宅配便コンパクトにてお送りください。
          </PreLabel>
          <PreLabel>
            ※上記以外のご本人様確認書類や、書類に不備がある場合(有効期限が切れている/確認できない項目がある
          </PreLabel>
          <PreLabel>等)はご利用いただけません。</PreLabel>
        </Pre>
      </div>
    </Section>
  );
});

Agreement.displayName = "Agreement";
